export const PRIVAT_INITIAL_ROUTE = `/profile`
